import type { DayOfWeekStats } from '@/pages/analytics/hooks/usePlanAnalytics';
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import * as React from 'react';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

interface DayOfWeekChartProps {
  data: DayOfWeekStats[];
}

export const DayOfWeekChart: React.FC<DayOfWeekChartProps> = ({ data }) => {
  const chartData = {
    labels: data.map(item => item.day.slice(0, 3)), // Mon, Tue, Wed...
    datasets: [
      {
        label: 'Plans',
        data: data.map(item => item.count),
        backgroundColor: 'rgba(99, 102, 241, 0.8)',
        borderRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: 'white',
        titleColor: '#1f2937',
        bodyColor: '#4b5563',
        borderColor: '#e5e7eb',
        borderWidth: 1,
        padding: 12,
        cornerRadius: 8,
        callbacks: {
          title: (items: { dataIndex: number }[]) => {
            const index = items[0]?.dataIndex;
            return index !== undefined &&
              index >= 0 &&
              index < data.length &&
              data[index]
              ? data[index].day
              : '';
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 11,
          },
          color: '#6b7280',
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: '#f3f4f6',
        },
        ticks: {
          font: {
            size: 11,
          },
          color: '#6b7280',
          stepSize: 1,
        },
      },
    },
  };

  return (
    <div className='h-48'>
      <Bar data={chartData} options={options} />
    </div>
  );
};
